export const applyHighchartsTheme = () => {
  const drupalThemeName = drupalSettings.ajaxPageState.theme;
  let themeColors;

  if (drupalThemeName === 'vontobel') {
    themeColors = [
      /**
       * Vontobel brand colors
       * See: web/src/scss/guides/_variables.scss
       */
      '#373a36',
      '#77c5d5',
      '#ffd400',
      '#f1567b',
      '#00a499',
      '#702082',
      '#548a96',
      '#cba924',
      '#a73d56',
      '#247269',
    ];
  } else {
    themeColors = [
      /**
       * 24am brand colors
       */
      '#006237',
      '#00a547',
      '#9fc53b',
      '#caea7e',
      '#29a7af',
      '#93d3d7',
      '#c9e9eb',
      '#000000',
      '#7e7e7e',
      '#bebebe',
      '#ffcc03',
      '#ffe57e',
      '#fff1be',
    ];
  }
  Highcharts.theme = {
    colors: themeColors,
    chart: {
      backgroundColor: null,
      style: {
        fontFamily: 'inherit',
      },
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      headerFormat: '<span style="font-size: 12px">{point.key}</span><br/>',
      borderWidth: 0,
      backgroundColor: '#f7f7f7',
    },
  };
  // Apply the theme
  Highcharts.setOptions(Highcharts.theme);
};

export const applyHighchartsTranslations = () => {
  Highcharts.setOptions({
    lang: {
      months: [
        Drupal.t('January'),
        Drupal.t('February'),
        Drupal.t('March'),
        Drupal.t('April'),
        Drupal.t('May'),
        Drupal.t('June'),
        Drupal.t('July'),
        Drupal.t('August'),
        Drupal.t('September'),
        Drupal.t('October'),
        Drupal.t('November'),
        Drupal.t('December'),
      ],
      shortMonths: [
        Drupal.t('Jan'),
        Drupal.t('Feb'),
        Drupal.t('Mar'),
        Drupal.t('Apr'),
        Drupal.t('May'),
        Drupal.t('Jun'),
        Drupal.t('Jul'),
        Drupal.t('Aug'),
        Drupal.t('Sep'),
        Drupal.t('Oct'),
        Drupal.t('Nov'),
        Drupal.t('Dec'),
      ],
      weekdays: [
        Drupal.t('Sunday'),
        Drupal.t('Monday'),
        Drupal.t('Tuesday'),
        Drupal.t('Wednesday'),
        Drupal.t('Thursday'),
        Drupal.t('Friday'),
        Drupal.t('Saturday'),
      ],
      rangeSelectorZoom: Drupal.t('Zoom'),
      rangeSelectorFrom: Drupal.t('From'),
      rangeSelectorTo: Drupal.t('To'),
    },
    rangeSelector: {
      buttons: [
        {
          type: 'month',
          count: 3,
          text: Drupal.t('3m'),
        },
        {
          type: 'month',
          count: 6,
          text: Drupal.t('6m'),
        },
        {
          type: 'year',
          count: 1,
          text: Drupal.t('1y'),
        },
        {
          type: 'year',
          count: 3,
          text: Drupal.t('3y'),
        },
        {
          type: 'year',
          count: 5,
          text: Drupal.t('5y'),
        },
        {
          type: 'all',
          text: Drupal.t('All'),
        },
      ],
    },
  });
};

export const applyHighchartsNumbersLocalization = () => {
  Highcharts.wrap(Highcharts, 'numberFormat', function (proceed) {
    let number = proceed.apply(0, [].slice.call(arguments, 1));

    if (number.indexOf('.') !== -1) {
      number = parseFloat(number).toLocaleString(drupalSettings.path.currentLanguage);
    }

    return number;
  });
};

// Implementation of lodash.get function
export const get = (object, keys, defaultVal) => {
  keys = Array.isArray(keys) ? keys : keys.split('.');
  object = object[keys[0]];
  if (object && keys.length > 1) {
    return get(object, keys.slice(1));
  }

  return object === undefined ? defaultVal : object;
};

export const l10nNumber = (number, isPercentage) => {
  return isPercentage
    ? parseFloat((number / 100).toFixed(4)).toLocaleString(drupalSettings.path.currentLanguage, {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })
    : number.toLocaleString(drupalSettings.path.currentLanguage, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
};

export class BaseChartComponent {
  constructor(selector, masterData) {
    this.element = jQuery(selector);
    this.masterData = masterData;
  }

  init() {
    jQuery(() => {
      this.data = this.mapData(this.masterData);

      if (!this.data || !this.element.length) {
        return;
      }

      if (typeof Highcharts === 'undefined') {
        console.warn('No Highcharts library detected'); // eslint-disable-line no-console

        return;
      }

      applyHighchartsTheme();
      applyHighchartsTranslations();
      applyHighchartsNumbersLocalization();
      this.makeChart();
    });
  }

  mapData(data) {
    console.error('mapData not implemented', this, data); // eslint-disable-line no-console
  }

  makeChart() {
    console.error('makeChart not implemented', this); // eslint-disable-line no-console
  }
}
